/**
 * Adds the given value to the map
 * cascading down map[lat][lot] = value
 * @param {Map<string, []any>} map
 * @param {number} lat
 * @param {number} lon
 * @param {any} value
 */
function sortIntoMap(map, lat, lon, value) {
    const key = `${lat}-${lon}`;
    if (!map.has(key)) {
        map.set(key, []);
    }
    const v = map.get(key);
    v.push(value);
    map.set(key, v);
}

/**
 * Calculates the map precision based on the given
 * zoom level
 * @param {number} zoomLevel
 * @return {number}
 */
function getPrecision(zoomLevel) {
    if (zoomLevel <= 8) {
        return 8;
    }
    switch (zoomLevel) {
        case 9:
        case 10:
        case 11:
            return 7;
        case 12:
        case 13:
            return 6;
        case 14:
        case 15:
        case 16:
            return 5;
        case 17:
            return 4;
        default:
            return 0;
    }
}


/**
 * Cluster the locations based on the zoom level
 * @param {Object[]} locations
 * @param {number} zoomLevel
 * @returns {Object[]}
 */
export function clusterLocations(locations, zoomLevel) {
    const map = new Map();
    const fac = Math.pow(10, 7)
    const filter = Math.pow(10, getPrecision(zoomLevel));
    locations.forEach(loc => {
        const tLat = Math.round(loc.coords.lat * fac / filter);
        const tLon = Math.round(loc.coords.lon * fac / filter);
        sortIntoMap(map, tLat, tLon, loc)
    });

    const clusters = Array.from(map.values());
    return clusters.map(cluster => {
        let lat = 0;
        let lon = 0;
        cluster.forEach(pin => {
            lat += pin.coords.lat / cluster.length;
            lon += pin.coords.lon / cluster.length;
        });
        return {
            coords: {
                lat,
                lon
            },
            count: cluster.length,
            locations: cluster
        }
    });
}